import { createContext, useContext, useState } from 'react';
import content from './lang';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState('en');
  const t = content[lang];
  const toggle = () => setLang((l) => (l === 'en' ? 'hi' : 'en'));
  return (
    <LangContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
